$(document).ready(function() {
    const stickyAddToCart =  document.querySelector(".main_product");
  const newSticky = document.querySelector(".buy-button-section-wrapper");
 window.addEventListener("scroll", () => {
        var observer = new IntersectionObserver(function(entries) {
            entries.forEach(function(entry) {
                if (entry.isIntersecting) {
                  newSticky.classList.remove("active");	
                } else {
                   newSticky.classList.add("active");	
                }
            });
        });

        observer.observe(stickyAddToCart);
  });
});



